import React, { useRef } from "react";
import { Grid } from "../../../components/Grid.components";
import { Boxed } from "../../../components/Boxed.components";
import { Text } from "../../../components/Text.components";
import { Button } from "../../../components/Button.components";
import { ModalComponent } from "../../../components/Modal.components";
import { PageTitle } from "../../../components/style";
import { Theme } from "../../../utils/theme";

export const MFAModal = (props) => {
  const inputRef = useRef([]);
  const buttonRef = useRef();

  // State props
  const { mfaModal, isLoading } = props;

  // Dispatch props
  const { form, closeModal, verifyMFA } = props;
  const { getFieldProps, getFieldError, validateFields } = form;

  let mfaList = [
    "digit_1",
    "digit_2",
    "digit_3",
    "_",
    "digit_4",
    "digit_5",
    "digit_6",
  ];

  const handleChange = (element, index) => {
    element.stopPropagation();
    const value = element?.target?.value;
    if (index < 6 && value !== "") {
      const nextIndex = index === 2 ? 4 : index + 1;
      inputRef?.current?.children[nextIndex]?.focus();
    }

    if (index > 0 && value === "") {
      const nextIndex = index === 4 ? 2 : index - 1;
      inputRef?.current?.children[nextIndex]?.focus();
    }

    if (index === 6) {
      buttonRef?.current?.focus();
    }
  };

  const onSubmit = () => {
    validateFields((error, values) => {
      if (!error) {
        let otp = "";
        mfaList.forEach((item, index) => {
          if (index !== 3) {
            otp += values[item];
          }
        });
        console.log({ otp });
        verifyMFA(otp);
      }
    });
  };

  if (!mfaModal) return null;

  return (
    <>
      <ModalComponent
        centered
        show={mfaModal}
        onHide={closeModal}
        title={
          <PageTitle margin="5px 0">Multi-Factor Authentication</PageTitle>
        }
        footer={
          <Boxed display="flex" width="100%">
            <Button clear onClick={closeModal}>
              Cancel
            </Button>
            <Button
              style={{ margin: "0 0 0 auto" }}
              progress={isLoading}
              disabled={isLoading}
              onClick={onSubmit}
              ref={buttonRef}
            >
              Authenticate
            </Button>
          </Boxed>
        }
      >
        <Text>
          An Email has been sent to your Account, Please enter the 6 digit pin
          provided in the your email to successfully create an account.
        </Text>
        <Grid
          desktop="repeat(7, 1fr)"
          tablet="repeat(7, 1fr)"
          mobile="repeat(7,1fr)"
          pad="0 0 30px 0"
          ref={inputRef}
        >
          {mfaList?.map((item, index) => {
            if (index === 3) {
              return <div key={index} />;
            }
            return (
              <input
                key={index}
                type="text"
                placeholder="*"
                minLength={1}
                disabled={isLoading}
                {...getFieldProps(item, {
                  initialValue: "",
                  rules: [{ required: true }],
                  onChange: (e) => handleChange(e, index),
                })}
                style={{
                  textAlign: "center",
                  padding: "8px 10px",
                  margin: "0 5px",
                  outline: "none",
                  borderRadius: Theme.PrimaryRadius,
                  width: "50px",
                }}
              />
            );
          })}
        </Grid>
      </ModalComponent>
    </>
  );
};
